export enum PaymentTypeEnum {
  CREDIT_CARD = 1,
  CASH = 2,
  CURRENT_ACCOUT = 3,
  FREE = 4,
  DISCOUNT_COUPON = 5,
  CHEQUE = 6,
  VOUCHER = 7,
  EFT = 8,
  BONUS = 9,
  ONLINE = 10
}
export const PaymentTypeEnumValues = [
  PaymentTypeEnum.CREDIT_CARD,
  PaymentTypeEnum.CASH,
  PaymentTypeEnum.CURRENT_ACCOUT,
  PaymentTypeEnum.EFT,
  PaymentTypeEnum.BONUS,
  PaymentTypeEnum.ONLINE,
  PaymentTypeEnum.CHEQUE,
  PaymentTypeEnum.VOUCHER,
  PaymentTypeEnum.FREE,
  PaymentTypeEnum.DISCOUNT_COUPON,]

export const PaymentTypeCashRegisterEnumValues = [
  PaymentTypeEnum.CREDIT_CARD,
  PaymentTypeEnum.CASH,
  PaymentTypeEnum.CURRENT_ACCOUT,
  PaymentTypeEnum.EFT,
  PaymentTypeEnum.CHEQUE,
  PaymentTypeEnum.VOUCHER,]
export const PaymentTypeCurrentAccountEnumValues = [
  PaymentTypeEnum.CREDIT_CARD,
  PaymentTypeEnum.CASH,
  PaymentTypeEnum.EFT,
  PaymentTypeEnum.CHEQUE,
  PaymentTypeEnum.VOUCHER,
  PaymentTypeEnum.ONLINE]

export const PaymentTypeEmployeePaymentEnumValues = [
  PaymentTypeEnum.CASH,
  PaymentTypeEnum.EFT]


export const PaymentTypeCurrencyExchangeEnumValues = [
  PaymentTypeEnum.CASH,
  PaymentTypeEnum.EFT,
  PaymentTypeEnum.ONLINE]

export const PaymentTypeExpenseEnumValues = [
  PaymentTypeEnum.CASH,
  PaymentTypeEnum.CREDIT_CARD,
  PaymentTypeEnum.EFT,
  PaymentTypeEnum.CHEQUE,
  PaymentTypeEnum.VOUCHER
]

export const PaymentTypeStoreMoneyEnumValues = [
  PaymentTypeEnum.CASH,
  PaymentTypeEnum.EFT,
  PaymentTypeEnum.CREDIT_CARD,
  PaymentTypeEnum.ONLINE,
  PaymentTypeEnum.CHEQUE,
  PaymentTypeEnum.VOUCHER
]

export const PaymentTypeStoreMoneyTransferEnumValues = [
  PaymentTypeEnum.CASH,
  PaymentTypeEnum.EFT,
  PaymentTypeEnum.CREDIT_CARD
]